







import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import ClientListTable from '@/components/ClientListTable.vue';

@Component({
	components: {
		ClientListTable
	},
	computed: {
		...mapState(['auth'])
	}
})
export default class ListClientsView extends Vue {

}
